<template>
  <div>
    <div
      v-if="formData.modifyByName"
      class="d-flex mb-1"
      style="font-size: 14px; color: #606266"
    >
      <div
        class="side-frame-success"
        style="height: inherit;margin: 0;min-height: 21px;"
      />
      <div>
        Modify：{{ formData.modifyByName || '--' }} at
        {{ formData.modifyTime || '--' }}
      </div>
    </div>

    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('form_label_refreshToken') || '账户刷新令牌'"
            prop="refreshToken"
          >
            <el-input
              v-model="formData.refreshToken"
              :placeholder="$l('INDEX.tips_input_placeholder')"
              :maxlength="500"
              show-word-limit
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$l('form_label_remark') || '备注'">
            <el-input
              v-model="formData.remark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              rows="4"
              :maxlength="500"
              show-word-limit
            />
          </el-form-item>
        </el-col>
      </el-row>

      <AccountStoreTable
        ref="accountStoreTable"
        :disabled="disabled"
        :amzAppAccountCode="amzAppAccountCode"
      />
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import AccountStoreTable from '../account-store-table'
export default {
  mixins: [EditLoading],
  components: { AccountStoreTable },
  props: {
    disabled: { type: Boolean, default: false },
    amzAppCode: { type: String, default: '' },
    amzAppAccountCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      formData: {},
      rules: {
        refreshToken: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
      },
      listAmzStore: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.amzAppAccountCode) return
      const res = await this.$api
        .ecomAmzAppAccountDetailApi({
          amzAppAccountCode: this.amzAppAccountCode,
        })
        .catch(() => null)
      this.formData = res?.body || {}
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])

      const listAmzStore = this.$refs.accountStoreTable.getTableData()
      if (!listAmzStore?.length) {
        this.$message({
          message: '账号店铺不能为空，请添加！',
          type: 'warning',
        })
      }

      if (!result || !listAmzStore?.length) {
        return (this.backDialogVisible = false)
      }

      if (this.loadingOpen()) return

      const listAmzStoreCode = listAmzStore.map(
        ({ amzStoreCode }) => amzStoreCode
      )
      const params = {
        ...this.formData,
        amzAppCode: this.amzAppCode,
        listAmzStoreCode,
      }
      const res = await this.$api
        .ecomAmzAppAccountSaveApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || res.msg,
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) return this.close()
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
